// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ec950393","897":"8ee40adf"}[chunkId] + ".chunk.js";
};